<div class="fp-loader">
  <div class="fp-loader__logo">
    <img src="../../../assets/images/logo.png">
  </div>
</div>
